import { observable } from 'mobx'

class Store {
  @observable tab = '1' // 1 推广数据，2 套包管理

  changeTab = tab => {
    this.tab = tab
  }

  changeToPackageTab = () => {
    this.changeTab('2')
  }
}

export default Store
